import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Search from "../pages/search/page";
import News from "../pages/news/page";
import Video from "../pages/video/page";
import Encyclopedia from "../pages/encyclopedia/page";
import Detail from "../pages/detail/page";
import HotSearch from "../pages/hotsearch/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/video",
    element: <Video />,
  },
  {
    path: "/encyclopedia",
    element: <Encyclopedia />,
  },
  {
    path: "/detail/:type/:id",
    element: <Detail />,
  },
  {
    path: "/hotsearch",
    element: <HotSearch />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;